export default __webpack_public_path__ + "static/media/Quote.03ea0e5f.svg";